import { getTasksQuery } from '@griply/services';
import { ID, QueryFilterOptions, Task } from '@griply/types';
import {
  collection,
  CollectionReference,
  Firestore,
  orderBy,
  Query,
  query,
  QueryConstraint,
  where,
} from 'firebase/firestore';

import { taskConverter } from './converters/task';
import { getDatabase } from './helpers';

export const getFilteredTasks = async (uid: ID, filters: QueryFilterOptions) =>
  getTasksQuery<CollectionReference, Query<Task>, QueryConstraint, Firestore>({
    db: getDatabase(),
    collection,
    query,
    where,
    orderBy,
    uid,
    ...filters,
  }).withConverter(taskConverter);
